import { DungChungService } from './../../../dung-chung/__services/dung-chung.service';
import {Component,
		OnInit,
		ViewChild,
		ChangeDetectionStrategy,
		ChangeDetectorRef,
		Inject,
		ViewRef
	}
from '@angular/core';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import moment from 'moment';
import { DatePipe } from '@angular/common';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatOptionSelectionChange } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { ThongTinHangVeService } from '../phieu-thong-tin-hang-ve-ver2-service/phieu-thong-tin-hang-ve-ver2.service';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { KeHoachHangVeTTHVService } from '../ke-hoach-hang-ve-service/ke-hoach-hang-ve.service';
//Model
import { DeNghiNhapKho, DeNghiNhapKhoChiTiet, KeHoachHangVe, FileDinhKem, DSFileImport, FileImport } from '../phieu-thong-tin-hang-ve-ver2-model/phieu-thong-tin-hang-ve-ver2.model';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
//Component
import { KeHoachHangVeListVer2DialogComponent } from '../ke-hoach-hang-ve-list-ver2-dialog/ke-hoach-hang-ve-ver2-list-dialog.component'
import { TimKiemNangCaoListComponent } from '../../../../tim-kiem-nang-cao/tim-kiem-nang-cao.component';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';

@Component({
	selector: 'm-phieu-thong-tin-hang-ve-ver2-add-edit',
	templateUrl: './phieu-thong-tin-hang-ve-ver2-add-edit.component.html',
	styleUrls: ['../phieu-thong-tin-hang-ve-ver2.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class ThongTinHangVeAddEditVer2Component implements OnInit {

	@ViewChild(CdkVirtualScrollViewport, { static: false }) cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
	@ViewChild('fileUpload', { static: true }) fileUpload;
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;


	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/

	/*--------------------Comment columns mat-table----------------------*/
	displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongkehoach',
            displayName: 'SL kế hoạch',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongchungtu',
            displayName: 'SL chứng từ',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoLuongThucNhap',
            displayName: 'SL thực giao',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Warning',
            displayName: 'Cảnh báo SL KH & TG',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SLTangGiam',
            displayName: 'SL tăng/giảm',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SoMay',
            displayName: 'Mã sub lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'MaNCC',
            displayName: 'Mã NCC',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 10,
            name: 'TenNCC',
            displayName: 'Nhà cung cấp',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'Nguoinhanhang',
            displayName: 'Người nhận hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'TenPBKiemTra',
            displayName: 'Phòng ban kiểm tra',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'Ghichulohang',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 13,
			name: 'TrangThaiPassHang',
			displayName: 'Trạng thái pass hàng',
			alwaysChecked: false,
			isShow: true
		},
        {
            stt: 99,
            name: 'actions',
            displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
        }
	];
	KHTraColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongkehoach',
            displayName: 'SL kế hoạch',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongchungtu',
            displayName: 'SL chứng từ',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoLuongThucNhap',
            displayName: 'SL thực giao',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Warning',
            displayName: 'Cảnh báo SL KH & TG',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SLTangGiam',
            displayName: 'SL tăng/giảm',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SoMay',
            displayName: 'Mã sub lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'MaNCC',
            displayName: 'Mã NCC',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 10,
            name: 'TenNCC',
            displayName: 'Nhà cung cấp',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'Nguoinhanhang',
            displayName: 'Người nhận hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'TenPBKiemTra',
            displayName: 'Phòng ban kiểm tra',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'Ghichulohang',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 13,
			name: 'TrangThaiPassHang',
			displayName: 'Trạng thái pass hàng',
			alwaysChecked: false,
			isShow: true
		},
        {
            stt: 99,
            name: 'actions',
            displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
        }
	];
	NCCGiaoColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongkehoach',
            displayName: 'SL kế hoạch',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongchungtu',
            displayName: 'SL chứng từ',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoLuongThucNhap',
            displayName: 'SL thực giao',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Warning',
            displayName: 'Cảnh báo SL KH & TG',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SLTangGiam',
            displayName: 'SL tăng/giảm',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SoMay',
            displayName: 'Mã sub lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoPhieuDNMH',
            displayName: 'Số phiếu ĐNMH',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoPhieuDH',
            displayName: 'Số phiếu ĐHM',
            alwaysChecked: false,
			isShow: true
		},
	
		{
            stt: 9,
            name: 'MaNCC',
            displayName: 'Mã NCC',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 10,
            name: 'TenNCC',
            displayName: 'Nhà cung cấp',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'Nguoinhanhang',
            displayName: 'Người nhận hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'TenPBKiemTra',
            displayName: 'Phòng ban kiểm tra',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'Ghichulohang',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 13,
			name: 'TrangThaiPassHang',
			displayName: 'Trạng thái pass hàng',
			alwaysChecked: false,
			isShow: true
		},
        {
            stt: 99,
            name: 'actions',
            displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
        }
	];
	HangXuLyColumn = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongkehoach',
            displayName: 'SL kế hoạch',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongchungtu',
            displayName: 'SL chứng từ',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoLuongThucNhap',
            displayName: 'SL thực giao',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Warning',
            displayName: 'Cảnh báo SL KH & TG',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SLTangGiam',
            displayName: 'SL tăng/giảm',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SoMay',
            displayName: 'Mã sub lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoPhieuXK',
            displayName: 'Số phiếu XK',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'Nguoinhanhang',
            displayName: 'Người nhận hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'TenPBKiemTra',
            displayName: 'Phòng ban kiểm tra',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'Ghichulohang',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 13,
			name: 'TrangThaiPassHang',
			displayName: 'Trạng thái pass hàng',
			alwaysChecked: false,
			isShow: true
		},
        {
            stt: 99,
            name: 'actions',
            displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
        }
	];

	displayedFileTable = [];
	FileTableColumn = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
            stt: 2,
            name: 'FileName',
            displayName: 'Tên tệp',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 3,
            name: 'GhiChu',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 99,
            name: 'actions',
            displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
        }
	];
	/* ------------------------------------------------------------------*/


	/*--------------------Mat select search cho hàng hóa-----------------*/
	listId_HH : any[] = [];
	selectId_HH : string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	/* ------------------------------------------------------------------ */


	/*----------------- Mat select search cho nhà cung cấp----------------*/
	listId_NCC : any[] = [];
	selectId_NCC : string = '';
	filteredId_NCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_NCCFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


	/*----------------Mat select search cho người nhân hàng---------------*/
	listId_NV : any[] = [];
	selectId_NV : string = '';
	filteredId_NV: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_NVFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


	/* Mat select search cho phòng ban kiểm tra trên formcontrol*/
	listId_BPKT : any[] = [];
	selectId_BPKT : string = '';
	filteredId_BPKT: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_BPKTFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


	/*------ Mat select search cho nhân viên nhận hàng - QC kiểm tra------*/
	listIdNV : any[] = [];
	selectIdNV : string = '';
	filteredIdNV: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdNVFilterCtrl: string = '';
	haveElementIdNV: boolean = false;
	arrayNVForEachHH: any[] = [];
	/* ------------------------------------------------------------------ */


	/*-------Mat select search cho nhân viên nhận hàng - QC kiểm tra -----*/
	listIdPBKT : any[] = [];
	selectIdPBKT : string = '';
	filteredIdPBKT: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdPBKTFilterCtrl: string = '';
	haveElementIdPBKT: boolean = false;
	arrayIdPBKTForEachHH: any[] = [];
	/* ------------------------------------------------------------------ */


	/*------------------------ Danh sách trạng thái ----------------------*/
	listState : any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */


	/* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DeNghiNhapKhoChiTiet>(true, []);

	selectedFileTableColumns = new SelectionModel<any>(true, this.FileTableColumn);
	selectionFileTable = new SelectionModel<FileDinhKem>(true, []);
	/* ------------------------------------------------------------------ */


	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */
	
	
	/* ------------------- Các form trên dialog --------------------------*/
	ThongTinHangVeForm: FormGroup;				
	PhieuTTHangVeHHForm: FormGroup;		
	FileForm: FormGroup;		
	/* ------------------------------------------------------------------ */


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	thongTinHangVeItem: DeNghiNhapKho;

	listChiTietHangVe: DeNghiNhapKhoChiTiet[] = [];
	tmpChiTietHangVe: DeNghiNhapKhoChiTiet[] = [];
	returnListKeHoachHangVe: KeHoachHangVe[] = [];
	/* ------------------------------------------------------------------ */


	/* ----------------------- Xử lý File đính kèm -----------------------*/
	listFileName: string[] = [];
	listFileDinhKem: FileDinhKem[] = [];
	dataArray: FileImport[] = [];
	/* ------------------------------------------------------------------ */
	

	/*------------------------- Extend field: ----------------------------*/
	title: string = '';	
	fixedPoint = 2;                		 // Số chữ số phần thập phân cho kiểu dữ liệu số.	
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	isChange: boolean = false;			// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	saveAddedTTHV: number[] = []		// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	listLoaiPhieu: any[];
	openTimKiemNangCao = false;
	flagChangeLoaiPhieu = -1;
	/* ------------------------------------------------------------------ */

	constructor(
		public dialogRef: MatDialogRef<ThongTinHangVeAddEditVer2Component>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private thongTinHangVeService: ThongTinHangVeService,
		private keHoachHangVeService: KeHoachHangVeTTHVService,
		private dungChungService : DungChungService,
		private ThongTinHangVeFB: FormBuilder,
		private PhieuTTHangVeHHFB: FormBuilder,
		private FileFB: FormBuilder,
		public dialog: MatDialog,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
	) {
		this.dialogRef.disableClose = true;
	}


	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit(){

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		/*Get data from list when open dialog */
		this.thongTinHangVeItem = this.data.data;
		this.listLoaiPhieu = DeNghiNhapKho.optionsLoaiPhieu;

		/*Load title of dialog */
		this.title = this.getTitle();
		this.createForm();

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_CLOSE.KeyCombine.keycode) {
				this.onSubmit(1);
			}
			else if(event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_NEW.KeyCombine.keycode){
				this.onSubmit(2);
			}
			else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_TMP.KeyCombine.keycode) {
				this.onSubmit(3);
			}
			
			this.changeDetectView();
		});

		/*Handel data import in dialog*/
		this.keHoachHangVeService.data_import.subscribe(res => {
			if(res != null && res != undefined){
				for(let i = 0; i < res.length; i++){
					let tmp = new FileImport();
					tmp.clear();
					tmp.filename = res[i].fileName;
					tmp.extension = res[i].extension;
					tmp.base64 = res[i].base64;

					this.dataArray.push(tmp)
				}
			}
		});

		/* Display columns */
		this.checkDisplayColumnsBaseOnForm();
		this.showColumnsInTable();
		this.applySelectedColumns();
		this.applyFileTableColumns();
	}
	ngAfterViewInit() {
		/*Load all dropdown and create form */
		this.ListId_HH();
		this.ListState();
		this.ListIdNv();
		this.LoadListBoPhanKiemTra();
		this.LoadListNcc();
	}
	ngOnDestroy() {
		this.keHoachHangVeService.data_import.next([]);
	}
	/* -----------------------------------------------------------------------*/
	 

	/*----------------- Create Form and handle event on form-- ---------------*/
	createForm(){

		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });

		/*Group các Form */
		this.ThongTinHangVeForm = this.ThongTinHangVeFB.group({
			SoPhieu: [!(this.thongTinHangVeItem.Sophieu == undefined || this.thongTinHangVeItem.Sophieu == '') ? this.thongTinHangVeItem.Sophieu : '', Validators.required],
			NgayLapPhieu: [!(this.thongTinHangVeItem.Ngaynhap == undefined || this.thongTinHangVeItem.Ngaynhap == '') ? this.thongTinHangVeItem.Ngaynhap : new Date(), Validators.required],
			TenNguoiLap: [this.thongTinHangVeItem.IdDn > 0 ? this.thongTinHangVeItem.TenNguoitao : tenNguoiLap],
			TrangThai: [this.nameState],
			LoaiPhieu:[this.thongTinHangVeItem.LoaiPhieu > 0 ? this.thongTinHangVeItem.LoaiPhieu.toString() : '1']
		});

		/*Disable các trường dữ liệu không thay đổi */
		this.ThongTinHangVeForm.disable();
		this.ThongTinHangVeForm.controls["LoaiPhieu"].enable();

		this.FileForm = this.FileFB.group({
			FileName: [''],
			GhiChu: ['']
		});

		this.PhieuTTHangVeHHForm = this.PhieuTTHangVeHHFB.group({
			idHh: ['',	Validators.required],
			TenHH: [''],
			QuyCach: [''],
			TenDVT: [''],
			soLo: ['', Validators.required],
			SoLuong:['0,00', Validators.compose([Validators.required, 
												Validators.min(0.01),
												Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER)])
					],
			SoLuongThucNhap:['0,00', Validators.compose([Validators.min(0.00),
												Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER_NOTREQUIRED)])
					],
			NguoiNhanHang:['',Validators.required],
			PbkiemTraId:['',Validators.required],
			Id_NCC:['',Validators.required],
			TenNCC:[],
		})

		this.flagChangeLoaiPhieu = +this.ThongTinHangVeForm.controls['LoaiPhieu'].value;
		/*Disable các trường dữ liệu không thay đổi */
		this.PhieuTTHangVeHHForm.controls["TenHH"].disable();
		this.PhieuTTHangVeHHForm.controls["QuyCach"].disable();
		this.PhieuTTHangVeHHForm.controls["TenDVT"].disable();
		this.PhieuTTHangVeHHForm.controls["TenNCC"].disable();
		/*------------------------------------------------------------------*/


		/*Add dữ liệu chi tiết */
		if(this.thongTinHangVeItem.listChiTietNhapKho != null && this.thongTinHangVeItem.listChiTietNhapKho.length > 0){
			this.listChiTietHangVe = this.thongTinHangVeItem.listChiTietNhapKho;
			this.tmpChiTietHangVe = [];
			for(let i = 0; i < this.listChiTietHangVe.length; i++){
				let tmpElement = new DeNghiNhapKhoChiTiet();
				tmpElement.copy(this.listChiTietHangVe[i])
				if(tmpElement.Nguoinhanhang == 0){
					tmpElement.Nguoinhanhang = +idUser
				}
				this.tmpChiTietHangVe.push(tmpElement);
			}
			this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];

			if(this.thongTinHangVeItem.listFileDinhKem != null
				&& this.thongTinHangVeItem.listFileDinhKem.length >0){
					this.listFileDinhKem = this.thongTinHangVeItem.listFileDinhKem;
					this.listFileDinhKem = [...this.listFileDinhKem];
			}
		}
		this.changeDetectView();
	}
	getTitle(): string {
		if (this.thongTinHangVeItem.IdDn > 0 ) {
			return `Chỉnh sửa phiếu TTHV`;
		}
		return 'Thêm mới phiếu TTHV';
	}
	getTrangThaiDetail(state: string){
		let item = DeNghiNhapKhoChiTiet.optionTrangThaiDetail.find(x => x.value == state)
		if(item != null){
			return item.name;
		}
		return '';
	}
	checkWarningState(item: DeNghiNhapKhoChiTiet){
		var tmp = Number(this.formatComparenumber(item.Soluongkehoach.toString())) * item.DungSai / 100;
		var result = -1;

		if(Number(this.formatComparenumber(item.SoLuongThucNhap.toString())) > Number(this.formatComparenumber(item.Soluongkehoach.toString())) + tmp){
			result = 0;
		}
		if((Number(this.formatComparenumber(item.Soluongkehoach.toString())) - tmp) <= Number(this.formatComparenumber(item.SoLuongThucNhap.toString()))
		&& (Number(this.formatComparenumber(item.SoLuongThucNhap.toString())) <= Number(this.formatComparenumber(item.Soluongkehoach.toString())) + tmp)){
			result = 1;
		}
		if(Number(this.formatComparenumber(item.SoLuongThucNhap.toString())) < Number(this.formatComparenumber(item.Soluongkehoach.toString())) - tmp){
			result = 2;
		}
		return result;
	}
	warningState(item: DeNghiNhapKhoChiTiet ){
		let result = this.checkWarningState(item);
		switch(result){
			case 0:
				return '> dung sai cho phép';
			case 1:
				return 'Thuộc dung sai cho phép';
			case 2:
				return '< dung sai cho phép';
			default:
				return ''
		}
	}
	cssWarningState(item:DeNghiNhapKhoChiTiet){
		let result = this.checkWarningState(item);
		switch(result){
			case 0:
				return 'red';
			case 1:
				return 'green';
			case 2:
				return 'orange';
			default:
				return ''
		}
	}
	holdValueLoaiPhieuBeforeChange(){
		this.ThongTinHangVeForm.controls['LoaiPhieu'].setValue(this.flagChangeLoaiPhieu.toString());
		this.changeDetectView();
	}
	checkChangeLoaiPhieu(value: any){
		if(this.tmpChiTietHangVe.length == 0){
			this.ThongTinHangVeForm.controls['LoaiPhieu'].setValue(value.toString())
			this.flagChangeLoaiPhieu = +this.ThongTinHangVeForm.controls['LoaiPhieu'].value
			this.acceptChangeLoaiPhieu();
		}
		else if(value != +this.ThongTinHangVeForm.controls['LoaiPhieu'].value){
			const dialogRef = this.layoutUtilsService.POPConfirm();
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					this.ThongTinHangVeForm.controls['LoaiPhieu'].setValue(this.flagChangeLoaiPhieu.toString())
					return;
				}
				this.ThongTinHangVeForm.controls['LoaiPhieu'].setValue(value.toString())
				this.flagChangeLoaiPhieu = +this.ThongTinHangVeForm.controls['LoaiPhieu'].value
				this.acceptChangeLoaiPhieu();
			});
		}
	}
	acceptChangeLoaiPhieu(){
		this.listChiTietHangVe = [];
		this.tmpChiTietHangVe = [];
		this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];
		this.arrayNVForEachHH=[];
		this.arrayIdPBKTForEachHH=[];
		this.data.selected = [];

		this.PhieuTTHangVeHHForm.reset();
		this.PhieuTTHangVeHHForm.controls["SoLuong"].setValue("0,00");
		this.PhieuTTHangVeHHForm.controls["SoLuongThucNhap"].setValue("0,00");

		this.checkDisplayColumnsBaseOnForm();
		this.applySelectedColumns();
		this.changeDetectView();

	}
	/* -----------------------------------------------------------------------*/
	

	/*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
	showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	applyFileTableColumns() {
		let _selectedColumns = this.selectedFileTableColumns.selected;
		this.selectedFileTableColumns = new SelectionModel<any>(true, this.FileTableColumn);
		for(let i = 0; i < this.FileTableColumn.length; i++){
			this.selectedFileTableColumns.toggle(this.FileTableColumn[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.FileTableColumn[i].name == _selectedColumns[j].name){
					this.selectedFileTableColumns.toggle(this.FileTableColumn[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedFileTableColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedFileTable = _applySelectedColumns;
	}
	checkDisplayColumnsBaseOnForm(){
		if(+this.ThongTinHangVeForm.controls['LoaiPhieu'].value == DeNghiNhapKho.optionsLoaiPhieu[0].value){
			this.availableColumns = this.KHTraColumns
		}
		else if(+this.ThongTinHangVeForm.controls['LoaiPhieu'].value ==  DeNghiNhapKho.optionsLoaiPhieu[1].value){
			this.availableColumns = this.NCCGiaoColumns
		}
		else if(this.ThongTinHangVeForm.controls['LoaiPhieu'].value == DeNghiNhapKho.optionsLoaiPhieu[2].value){
			this.availableColumns = this.HangXuLyColumn
		}
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	}
	/* -----------------------------------------------------------------------*/
	

	/*------------------------- Hàm lấy danh sách-----------------------------*/
	ListState(){
		this.keHoachHangVeService.listState().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetectView();
			};
		});
	}
	checkState(){
		this.listState.forEach(element => {
			if(element.Code == this.thongTinHangVeItem.Tinhtrang){
				this.nameState = element.Description;
				if(this.ThongTinHangVeForm != null)
					this.ThongTinHangVeForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}


	ListId_HH(){
		this.keHoachHangVeService.listHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	filterId_HH(searchTmp: string = '') {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if(searchTmp != '' )
			search = '' + searchTmp;

		if (!search) {
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if(searchTmp != ''){
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}
		else{
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.MaHang.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetectView();
	}
	changListHH() {
		let item = this.listId_HH.find(x => x.Id_HH == +this.PhieuTTHangVeHHForm.controls["idHh"].value);
		if(item != null){
			this.PhieuTTHangVeHHForm.controls["TenHH"].setValue(item.TenHH);
			this.PhieuTTHangVeHHForm.controls["QuyCach"].setValue(item.QuyCach);
			this.PhieuTTHangVeHHForm.controls["TenDVT"].setValue(item.TenDVT);
		}
		else{
			this.layoutUtilsService.showErorr('Không tìm thấy hàng hóa vừa chọn, vui lòng chọn lại!');
		}
		this.changeDetectView();
	}
	filterID_HH() {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if (!search) {
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredId_HH.next(
			this.listId_HH.filter(ts =>
				ts.MaHH.toLowerCase().indexOf(search) > -1||ts.TenHH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	showNameHH(value: any){
		let item = this.listId_HH.find(x => x.Id_HH == +value);
		if(item != null){
			return item.MaHH;
		}
		return '';
	}


	ListIdNv(){
		var phongban = '';
		this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });
		this.keHoachHangVeService.listNV().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listIdNV = res.data;
				this.filteredId_NV.next(res.data.slice());
				this.listChiTietHangVe.forEach(element =>{
					let filterTmp = new ReplaySubject<any[]>(1)
					filterTmp.next(this.listIdNV.slice());
					this.arrayNVForEachHH.push(filterTmp);
				})
				this.changeDetectView();
			};
		});
	}
	filterDropdown_IdNv() {
		if (!this.listIdNV) {
			return;
		}
		// get the search keyword
		let search = this.Id_NVFilterCtrl;
		if (!search) {
			this.filteredId_NV.next(this.listIdNV.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredId_NV.next(
			this.listIdNV.filter(ts =>
				ts.TenNV.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	filterIdNv(item: any) {
		if (!this.listIdNV) {
			return;
		}
		// get the search keyword
		let search = this.IdNVFilterCtrl;
		let index = this.tmpChiTietHangVe.indexOf(item)

		if (!search) {
			this.arrayNVForEachHH[index].next(this.listIdNV.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		if(index > -1){
			this.arrayNVForEachHH[index].next(this.listIdNV.filter(ts =>
				ts.TenNV.toLowerCase().indexOf(search) > -1)
			);
		}
		this.changeDetectView();
	}
	showNameNNH(value: any){
		let element = this.listIdNV.find(x => x.Id_NV == +value)
		if(element != null){
			return element.TenNV;
		}
		return '';
	}

	LoadListNcc(){
		this.thongTinHangVeService.listListNCC().subscribe(res => {
			if (res.status == 1) {
				this.listId_NCC=res.data;
				this.filteredId_NCC.next(this.listId_NCC.slice());
			}
		});
	}
	loadNCC(){
		var controls=this.PhieuTTHangVeHHForm.controls;
		var itemNCC=this.listId_NCC.filter(x=>x.Id_NCC==controls["Id_NCC"].value);
		controls["TenNCC"].setValue(itemNCC[0].TenNCC);
	}
	filterListNCC() {
		if (!this.listId_NCC) {
			return;
		}
		// get the search keyword
		let search = this.Id_NCCFilterCtrl;
		if (!search) {
			this.filteredId_NCC.next(this.listId_NCC.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredId_NCC.next(
			this.listId_NCC.filter(ts =>
				ts.TenNCC.toLowerCase().indexOf(search) > -1||ts.MaNCC.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	showNameNCC(value: any){
		let element = this.listId_NCC.find(x => x.Id_NCC == +value)
		if(element != null){
			return element.MaNCC;
		}
		return '';
	}

	LoadListBoPhanKiemTra(){
		this.dungChungService.listPhongBanAll().subscribe(res=>{
			if(res&&res.status==1){
				this.listIdPBKT = res.data;
				this.filteredId_BPKT.next(this.listIdPBKT.slice());
				this.listChiTietHangVe.forEach(element =>{
					let filterTmp = new ReplaySubject<any[]>(1)
					filterTmp.next(this.listIdPBKT.slice());
					this.arrayIdPBKTForEachHH.push(filterTmp);
				})
				this.changeDetectView();
			}
		})
	}
	filterIdPBKT(item: any) {
		if (!this.listIdPBKT) {
			return;
		}
		// get the search keyword
		let search = this.IdPBKTFilterCtrl;
		let index = this.tmpChiTietHangVe.indexOf(item)

		if (!search) {
			this.arrayIdPBKTForEachHH[index].next(this.listIdPBKT.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		if(index > -1){
			this.arrayIdPBKTForEachHH[index].next(this.listIdPBKT.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
			);
		}
		this.changeDetectView();
	}
	filterId_PBKT() {
		if (!this.listIdPBKT) {
			return;
		}
		// get the search keyword
		let search = this.Id_BPKTFilterCtrl;
		
		if (!search) {
			this.filteredId_BPKT.next(this.listIdPBKT.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		
			this.filteredId_BPKT.next(this.listIdPBKT.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
			);
	
		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/



	/*--------------------------- Hàm xử lý File------------------------------*/
	selectFile() {
		let el: HTMLElement = this.fileUpload.nativeElement as HTMLElement;
		el.click();
	}
	FileSelected(evt: any) {
		if (evt.target.files && evt.target.files.length) {
			
			for(let i = 0; i < evt.target.files.length; i++){
				let file = evt.target.files[i];
				let fileName = file.name;
				this.listFileName.push(fileName);
			}
			let listFileNameStr = this.listFileName[0];
			for(var i = 1; i < this.listFileDinhKem.length; i++){
				listFileNameStr += ', ' + this.listFileDinhKem[i];
			}
			this.FileForm.controls["FileName"].setValue(listFileNameStr);


			let el: any = this.fileUpload.nativeElement;
			var service = this.keHoachHangVeService;
			var useBase64: boolean = true;
			let tmpDataArray: any = [];

			for (var idx = 0; idx < el.files.length; idx++) {
				var extension = el.files[idx].name.split('.').pop();
				var fileName = el.files[idx].name.substring(0,el.files[idx].name.indexOf(extension) - 1);

				let reader = new FileReader();
				reader.readAsDataURL(el.files[idx]);
				reader.onload = function () {
					let base64Str = reader.result as String;
					var metaIdx = base64Str.indexOf(';base64,');

					base64Str = base64Str.substr(metaIdx + 8);
					var data = {
						fileName: fileName,
						base64: base64Str,
						extension: extension
					};

					tmpDataArray.push(data);
					service.data_import.next(tmpDataArray);
				};
			}
		}
		evt.target.type = 'text';
		evt.target.type = 'file';
	}
	addFile(){
		for(let i = 0; i < this.listFileName.length; i++){
			let tmp = new FileDinhKem();
			tmp.clear();
			tmp.FileName = this.listFileName[i];
			tmp.GhiChu = this.FileForm.controls["GhiChu"].value;

			this.listFileDinhKem.push(tmp);
		}
		this.listFileName = [];
		this.listFileDinhKem = [...this.listFileDinhKem];
		this.FileForm.controls["GhiChu"].setValue('');
		this.FileForm.controls["FileName"].setValue('');
		this.changeDetectView();
	}
	deleteFile(item: any){
		let _index = this.listFileDinhKem.findIndex(x => x.FileName == item.FileName);
		if(_index > -1){
			this.listFileDinhKem.splice(_index,1)
		}

		for(let i = 0; i < this.dataArray.length; i++){
			if(item.FileName.includes(this.dataArray[i].filename)){
				this.dataArray.splice(i,1);
				break;
			}
		}

		this.listFileDinhKem = [...this.listFileDinhKem];
		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/


	/*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string){
		let message = "";
		let controls = formGroup.controls;
		if(controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if(controls[columnName].hasError('maxlength') 
			|| (controls[columnName].value.length > 22 
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21))) 
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == ','){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == ','){
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string){
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	keyUpInputNumberVND(event){
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup){
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.formatComparenumber(data) < min && event.data && event.data == '0') data = this.f_currency_VND(this.formatNumber(min.toString()));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				
			}else{
				controls[columnName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup){
		let controls = formGroup.controls;
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");
			
			if(Number(tmpValue) < min) tmpValue = min;

			if(!controls[controlName].invalid){
				controls[controlName].setValue(
					this.f_currency_VND(this.formatNumber(tmpValue))
				);
			}
			if(tmpValue.indexOf(',') == 0 && tmpValue.length == 1){
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_currency_VND(this.formatNumber(tmpValue))
			);
		}
		else{
			controls[controlName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			//console.log(controls[controlName].value);
		}
	}
	changeInputNumberVNDInList(event : any, min: number = 0){
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.formatComparenumber(data) < min && event.data && event.data == '0') data = this.f_currency_VND(this.formatNumber(min.toString()));
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
			}else{
				event.target.value = this.f_currency_VND(this.formatNumber(min.toString()));
			}
			
			//this.changeDetect.detectChanges();
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: DeNghiNhapKhoChiTiet){
		
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = this.formatComparenumber(event.target.value.toString());
			
			if(Number(tmpValue) < min) tmpValue = min;

			if(!item[columnName]){
				item[columnName] = this.f_currency_VND(this.formatNumber(tmpValue.toString()));
			}

			if(tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1){
				tmpValue = min;
			}
			
			item[columnName] = this.f_currency_VND(this.formatNumber(tmpValue.toString()));
		}
		else{
			item[columnName] =this.f_currency_VND(this.formatNumber(min.toString()));
		}

		this.changeDetectView();
	}
	calculateSoLuongTangGiam(item: any){
		var value = this.formatComparenumber(item.SoLuongThucNhap.toString()) - this.formatComparenumber(item.Soluongkehoach.toString());
		if(value < 0)
			return this.f_currency_VND(value.toString())
		return "+" + this.f_currency_VND(value.toString())
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/* -----------------------------------------------------------------------*/


	/*---------------------------- Thao tác trên form ------------------------*/
	back(){
		this.dialogRef.close(
			{
				isChange: this.isChange,		//Dữ liệu có thay đổi hay không?
				dataAdd : this.returnListKeHoachHangVe,
				PTTHVNew : this.saveAddedTTHV
			}
		);
	}
	deleteItem(item: any){
		const index = this.tmpChiTietHangVe.indexOf(item, 0);
		let condition = false;
		if (index > -1) {
			let _indexSelected = this.data.selected.findIndex(x => x.Id == this.tmpChiTietHangVe[index].IdDHCT)
			if(_indexSelected > -1){
				this.data.selected.splice(_indexSelected, 1);
				condition = true;
			}
		}
		if(this.thongTinHangVeItem.IdDn > 0 || condition){
			this.tmpChiTietHangVe.splice(index, 1);
		}
		else{
			this.tmpChiTietHangVe.splice(index, 1);
		}

		this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];
	}
	addMoreDetail(){
		const dialogRef = this.dialog.open(KeHoachHangVeListVer2DialogComponent, {
			data: {
				data: this.data.selected,
			},
			maxHeight: '90vh',
			width: '90vw'
		});

		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
			else{
				
				if(res.dataAdd != null && res.dataAdd.length > 0){
					res.dataAdd.forEach(element =>{
						this.data.selected.push(element);

						let tmp = new DeNghiNhapKhoChiTiet();
						tmp.clear();
						tmp.IdHh = element.HangHoaId;
						tmp.MaHH = element.MaHang;
						tmp.TenHH = element.TenHang;
						tmp.QuyCach = element.QuyCach;
						tmp.DungSai = element.DungSai;
						tmp.MaNCC = element.MaNCC;
						tmp.TenNCC = element.TenNCC;
						tmp.TenDVT = element.TenDVT;
						tmp.Dvt = element.DVT;
						tmp.Soluongkehoach = element.SoLuong;
						tmp.Soluongchungtu = element.SoLuong;
						tmp.Nguoinhanhang =element.NguoiNhanHang;
						tmp.IdNcc = element.IdNCC;
						tmp.SoPhieuDH = element.SoPhieuDH;
						tmp.SoPhieuDNMH = element.SoPhieuDNMH;
						tmp.IdPhieuDH = element.IdPDH;
						tmp.PbkiemTraId = element.IdPB;
						tmp.TenPBKiemTra = element.TenPB;
						tmp.Ghichulohang = element.GhiChu;
						tmp.IdNguon = element.Id;
						tmp.NguonPhatSinh = DeNghiNhapKhoChiTiet.optionsNguonPhatSinh[0].value;
						tmp.IdDHCT = element.Id;
						tmp.LoaiPhieu = element.LoaiPhieu;
						tmp.TrangThaiPassHang = DeNghiNhapKhoChiTiet.optionTrangThaiDetail[0].value;
						this.tmpChiTietHangVe.push(tmp);

						let filterTmp = new ReplaySubject<any[]>(1)
						filterTmp.next(this.listIdNV.slice());
						this.arrayNVForEachHH.push(filterTmp);
						
						let filterPBkiemTra= new ReplaySubject<any[]>(1)
						filterPBkiemTra.next(this.listIdPBKT.slice());
						this.arrayIdPBKTForEachHH.push(filterPBkiemTra);
						
					})
					this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];
					this.scrollToBottom();
					this.changeDetectView();
				}
			}
		});
	}
	addDetailMatHang(){

		const HHcontrols= this.PhieuTTHangVeHHForm.controls;

		let itemHH = this.listId_HH.find(x => x.Id_HH == +HHcontrols["idHh"].value);
		let itemNCC = this.listId_NCC.find(x => x.Id_NCC == +HHcontrols["Id_NCC"].value);

		let itemCT=new DeNghiNhapKhoChiTiet();
		itemCT.clear();
		itemCT.IdHh = itemHH.Id_HH
		itemCT.MaHH = itemHH.MaHH
		itemCT.TenHH = itemHH.TenHH
		itemCT.QuyCach = itemHH.QuyCach
		itemCT.DungSai = itemHH.DungSai

		itemCT.TenDVT = itemHH[0].TenDVT
		itemCT.Solo = HHcontrols["soLo"].value;
		itemCT.Soluongkehoach = '0.00';
		itemCT.Soluongchungtu = HHcontrols["SoLuong"].value;
		itemCT.SoLuongThucNhap = HHcontrols["SoLuongThucNhap"].value;
		itemCT.Nguoinhanhang = HHcontrols["NguoiNhanHang"].value;
		itemCT.Dvt= itemHH[0].DVT;
		itemCT.TenNCC=itemNCC[0].TenNCC;
		itemCT.IdNcc=itemNCC[0].Id_NCC;
		itemCT.MaNCC=itemNCC[0].MaNCC;
		itemCT.PbkiemTraId= HHcontrols["PbkiemTraId"].value;
		itemCT.TrangThaiPassHang = DeNghiNhapKhoChiTiet.optionTrangThaiDetail[0].value;

		this.tmpChiTietHangVe.push(itemCT);
		this.tmpChiTietHangVe=[...this.tmpChiTietHangVe];

		this.PhieuTTHangVeHHForm.reset();
		this.PhieuTTHangVeHHForm.controls["SoLuong"].setValue('0.00');
		this.PhieuTTHangVeHHForm.controls["SoLuongThucNhap"].setValue('0.00');
		//this.createForm();

		this.arrayNVForEachHH=[];
		this.arrayIdPBKTForEachHH=[];

		this.tmpChiTietHangVe.forEach(item=>{
			var filteritem_NV  = new ReplaySubject<any[]>(1);
			var filteritem_PB  = new ReplaySubject<any[]>(1);
			filteritem_NV.next(this.listIdNV.slice());
			filteritem_PB.next(this.listIdPBKT.slice());
			this.arrayNVForEachHH.push(filteritem_NV);
			this.arrayIdPBKTForEachHH.push(filteritem_PB);
		})
	
		this.scrollToBottom();
		this.changeDetectView();
		
	}
	onSubmit(type: number) {
		
		const controls = this.ThongTinHangVeForm.controls;
		if (this.tmpChiTietHangVe.length <= 0) {
			this.layoutUtilsService.showErorr('Vui lòng thêm thông tin hàng về');
			return null;
		}

		for (let index = 0; index < this.tmpChiTietHangVe.length; index++) {
			const element = this.tmpChiTietHangVe[index];
			if(element.IdHh <= 0){
				this.layoutUtilsService.showErorr('Vui lòng chọn hàng hóa');
				return ;
			}
			if(Number(this.tmpChiTietHangVe[index].Soluongchungtu) <= 0){
				this.layoutUtilsService.showErorr('SL chứng từ của mã hàng '+ this.tmpChiTietHangVe[index].MaHH + ' không được <= 0');
				return null;
			}
			if(element.Solo == ""){
				this.layoutUtilsService.showErorr('Số lô không được để trống ');
				return ;
			}
			if(element.PbkiemTraId==0){
				this.layoutUtilsService.showErorr('Phòng ban kiểm tra không được để trống ');
				return ;
			}
			if(element.Nguoinhanhang <=0){
				this.layoutUtilsService.showErorr('Vui lòng chọn người nhận hàng');
				return ;
			}
			if(element.IdNcc <=0){
				this.layoutUtilsService.showErorr('Vui lòng chọn NCC');
				return ;
			}
		}

		const _result = new DeNghiNhapKho();
		_result.clear();
		_result.Sophieu = controls["SoPhieu"].value;
		_result.Type = false;
		_result.Ngaynhap = moment(new Date(controls["NgayLapPhieu"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_result.Ngaytao = moment(new Date(controls["NgayLapPhieu"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_result.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[0].value;
		_result.listChiTietNhapKho = this.tmpChiTietHangVe;

		if(type == 1 || type == 2){
			_result.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[1].value;
		}

		if(type == 1 || type == 2){
			const dialogRef = this.layoutUtilsService.POP02(_result.Sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				if (this.thongTinHangVeItem.IdDn > 0) {
					_result.IdDn = this.thongTinHangVeItem.IdDn;
					_result.attachmentId = this.thongTinHangVeItem.attachmentId;
					_result.listFileDinhKem = this.listFileDinhKem;
		
					let listImport = new DSFileImport();
					listImport.clear();
		
					let saveFinalFile: FileImport[] = [];
					this.dataArray.forEach(element => {
						let _index = this.listFileDinhKem.findIndex(x =>
							x.FileName == (element.filename + "." + element.extension)
						);
						if(_index > -1){
							element.dienGiai = this.listFileDinhKem[_index].GhiChu;
							saveFinalFile.push(element);
						}
					})
					listImport.listImport = saveFinalFile;
		
					_result.FileImport = listImport;
					this.updateThongTinHangVe(_result,type)
					return;
				}
				this.addThongTinHangVe(_result,type);
			});
		}
		else{
			if (this.thongTinHangVeItem.IdDn > 0) {
				_result.IdDn = this.thongTinHangVeItem.IdDn;
				_result.attachmentId = this.thongTinHangVeItem.attachmentId;
				_result.listFileDinhKem = this.listFileDinhKem;
	
				let listImport = new DSFileImport();
				listImport.clear();
	
				let saveFinalFile: FileImport[] = [];
				this.dataArray.forEach(element => {
					let _index = this.listFileDinhKem.findIndex(x =>
						x.FileName == (element.filename + "." + element.extension)
					);
					if(_index > -1){
						element.dienGiai = this.listFileDinhKem[_index].GhiChu;
						saveFinalFile.push(element);
					}
				})
				listImport.listImport = saveFinalFile;
	
				_result.FileImport = listImport;
				this.updateThongTinHangVe(_result,type)
				return;
			}
			this.addThongTinHangVe(_result,type);
		}
	}
	updateThongTinHangVe(item: DeNghiNhapKho, withBack: number) {
		this.thongTinHangVeService.updateThongTinHangVeWithDetail(item).subscribe(res => {
			if (res.status == 1) {
				const message = `Phiếu thông tin hàng về cập nhật thành công`;
				this.layoutUtilsService.showInfo(message);

				this.returnListKeHoachHangVe = this.data.selected;
				let index = this.saveAddedTTHV.findIndex(x => x == res.data.IdDn);
				if(index == -1)
					this.saveAddedTTHV.push(res.data.IdDn);
				this.isChange = true;
				this.dataArray = [];

				if(withBack == 1){
					this.back();
				}
				else{
					this.ThongTinHangVeForm.controls["TrangThai"].setValue(DeNghiNhapKho.optionsTinhTrang[0].name);
					this.fileUpload.nativeElement.value = "";
					if(withBack == 2){
						this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
							if (res.status == 1) {
								this.ThongTinHangVeForm.controls["SoPhieu"].setValue(res.data);
								this.listChiTietHangVe = [];
								this.tmpChiTietHangVe = [];
								this.data.selected = [];
								this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];

								this.listFileDinhKem = [];
								this.listFileDinhKem = [...this.listFileDinhKem];
								this.thongTinHangVeItem.IdDn = 0;

								this.thongTinHangVeItem.Sophieu = res.data;
								this.title = this.getTitle();
								this.changeDetectView();
							}
							else {
								const message = `Lỗi lấy số phiếu tiếp theo`;
								this.layoutUtilsService.showErorr(message);
							}
						});
					}
					else if(withBack == 3){
						this.thongTinHangVeService.getThongTinHangVeDetail(item).subscribe(res => {
							if (res.status == 1) {
								this.thongTinHangVeItem = res.data;
								if(this.thongTinHangVeItem.listFileDinhKem != null
									&& this.thongTinHangVeItem.listFileDinhKem.length >0){
										this.listFileDinhKem = this.thongTinHangVeItem.listFileDinhKem;
										this.listFileDinhKem = [...this.listFileDinhKem];
								}
								this.changeDetectView();
							}
						});
					}
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	addThongTinHangVe(item: DeNghiNhapKho, withBack: number){
		let listImport = new DSFileImport();
		listImport.clear();
		let saveFinalFile: FileImport[] = [];
		this.dataArray.forEach(element => {
			let _index = this.listFileDinhKem.findIndex(x =>
				x.FileName == (element.filename + "." + element.extension)
			);
			if(_index > -1){
				element.dienGiai = this.listFileDinhKem[_index].GhiChu;
				saveFinalFile.push(element);
			}
		})
		listImport.listImport = saveFinalFile;

		if(this.dataArray.length > 0 && this.listFileDinhKem.length > 0){
			this.keHoachHangVeService.uploadFile(listImport).subscribe(res =>{
				if (res.status == 1){
					item.attachmentId = res.data;
					this.thongTinHangVeService.addThongTinHangVe(item).subscribe(res => {
						if (res.status == 1) {
							const message = `Phiếu thông tin hàng về mới đã được thêm.`;
							this.layoutUtilsService.showInfo(message);
							this.returnListKeHoachHangVe = this.data.selected
							
							let index = this.saveAddedTTHV.findIndex(x => x == res.data.IdDn);
							if(index == -1)
								this.saveAddedTTHV.push(res.data.IdDn);
							this.isChange = true;

							if(withBack == 1){
								this.back();
							}
							else{
								this.fileUpload.nativeElement.value = "";
								if(withBack == 2){
									this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
										if (res.status == 1) {
											this.ThongTinHangVeForm.controls["SoPhieu"].setValue(res.data);
											this.listChiTietHangVe = [];
											this.tmpChiTietHangVe = [];
											this.data.selected = [];
											

											this.listFileDinhKem = [];
											this.listFileDinhKem = [...this.listFileDinhKem];
											this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];
											this.thongTinHangVeItem.Sophieu = res.data;
											this.changeDetectView();
										}
										else {
											const message = `Lỗi lấy số phiếu tiếp theo`;
											this.layoutUtilsService.showErorr(message);
										}
									});
								}
								else if(withBack == 3){
									this.ThongTinHangVeForm.controls["TrangThai"].setValue(DeNghiNhapKho.optionsTinhTrang[0].name);
									this.thongTinHangVeItem.IdDn = res.data.IdDn;
								}
								this.title = this.getTitle();
							}
						}
						else {
							this.layoutUtilsService.showErorr(res.error.message);
						}
					});
				}
				else {
					this.layoutUtilsService.showErorr('Lỗi lưu File');
				}
			})
		}
		else{
			this.thongTinHangVeService.addThongTinHangVe(item).subscribe(res => {
				if (res.status == 1) {
					const message = `Phiếu thông tin hàng về mới đã được thêm.`;
					this.layoutUtilsService.showInfo(message);
					this.returnListKeHoachHangVe = this.data.selected
					let index = this.saveAddedTTHV.findIndex(x => x == res.data.IdDn);
					if(index == -1)
						this.saveAddedTTHV.push(res.data.IdDn);
					this.isChange = true;

					if(withBack == 1){
						this.back();
					}
					else{
						this.fileUpload.nativeElement.value = "";
						if(withBack == 2){
							this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
								if (res.status == 1) {
									this.ThongTinHangVeForm.controls["SoPhieu"].setValue(res.data);
									this.listChiTietHangVe = [];
									this.tmpChiTietHangVe = [];
									this.data.selected = [];
									this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];

									this.listFileDinhKem = [];
									this.listFileDinhKem = [...this.listFileDinhKem];
									this.thongTinHangVeItem.Sophieu = res.data;
									this.changeDetectView();
								}
								else {
									const message = `Lỗi lấy số phiếu tiếp theo`;
									this.layoutUtilsService.showErorr(message);
								}
							});
						}
						else if(withBack == 3){
							this.ThongTinHangVeForm.controls["TrangThai"].setValue(DeNghiNhapKho.optionsTinhTrang[0].name);
							this.thongTinHangVeItem.IdDn = res.data.IdDn;
						}
						this.title = this.getTitle();

					}
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});
		}
	}

	/* -----------------------------------------------------------------------*/


	/*------------------------------ Extend Options --------------------------*/
	timKiemNangCao(){
		this.openTimKiemNangCao = true;
		
		const dialogRef = this.dialog.open(TimKiemNangCaoListComponent, {
			data: {
				kw : this.Id_HHFilterCtrl
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openTimKiemNangCao = false;
			if (res == undefined || res == null) {
				return;
			}
			else{
				if (!res.isChange) {
					return;
				}
				if(res.dataAdd.length != 0){
					this.PhieuTTHangVeHHForm.controls["idHh"].setValue(res.dataAdd.toString());
					this.changListHH();
				}
			}
		});
	}
	openChange($event: boolean) {
		if ($event) {
		  this.cdkVirtualScrollViewPort.scrollToIndex(0);
		  this.cdkVirtualScrollViewPort.checkViewportSize();
		} else {
		}
	}
	scrollToBottom(){
		setTimeout(() => {
			let height = document.getElementById('dialog-form').scrollHeight
			document.getElementById('dialog-form').scrollTo({ top: height, behavior: 'smooth' });
		}, 500);
	}
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	/* -----------------------------------------------------------------------*/
}
